<div class="cookie-banner-wrapper" *ngIf="showCookieBanner">
    <div class="banner-opacity" (click)="dismissBanner()">
    </div>
    <div class="cookie-banner">
        <div>
            <div class="cookie-header">
                <img src="/assets/images/tp-logo.svg">
                <button mat-icon-button (click)="dismissBanner()"><mat-icon>close</mat-icon></button>
            </div>
            <div class="banner-title">We respect your privacy</div>
            <div class="banner-description">
                <div>
                    Essential cookies and technologies are used on our website, with the help of which we can offer you
                    a
                    secure connection, authentication and use of the website.
                </div>
                <div>
                    We explain details on the use of data and, if necessary, the transfer of data in our data protection
                    declaration.
                </div>
            </div>
        </div>
        <div class="banner-buttons">
            <button class="dismiss-button" mat-button (click)="dismissBanner()">Dismiss</button>
            <button mat-button (click)="openPrivacyPolicy()">Privacy policy</button>
        </div>
    </div>
</div>